export const SHARE_SERVICE_DASHBOARD_KEYS = {
  TRENDS: 'trends',
  NOC: 'realtime',
  APP_EXPERIENCE: 'app-experience',
  OVERVIEW: 'ovb',
};

export const trendsShareConfig = {
  page: { key: SHARE_SERVICE_DASHBOARD_KEYS.TRENDS },
};

export const nocShareConfig = {
  page: { key: SHARE_SERVICE_DASHBOARD_KEYS.NOC },
};

export const appExperienceShareConfig = {
  page: { key: SHARE_SERVICE_DASHBOARD_KEYS.APP_EXPERIENCE },
};

export const overviewShareConfig = {
  page: { key: SHARE_SERVICE_DASHBOARD_KEYS.OVERVIEW },
};
